import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/src/layout.tsx";
import { EmbedYoutube } from "../../components/Embed";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Content = makeShortcode("Content");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Content mdxType="Content">
      <p>{`Prítulné a priateľské psíky vás prevezú 1 km okruhom za hotelom Studničky a tešiť sa môžete aj na bohatý sprievodný
program:`}</p>
      <ul>
        <li parentName="ul">{`fotenie a mini párty s maskotom Olafom,`}</li>
        <li parentName="ul">{`detské hry a súťaže,`}</li>
        <li parentName="ul">{`maľovanie na tvár,`}</li>
        <li parentName="ul">{`ochutnávka likérov Tatrabalsam a súťaže.`}</li>
      </ul>
      <p>{`Cena:
6 € / dospelá osoba
4 € / dieťa do 18 rokov`}</p>
      <h2>{`Ako bolo minulý rok`}</h2>
      <EmbedYoutube code="_QYUCwsRQ7g" mdxType="EmbedYoutube" />
    </Content>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      